module.exports = {
  "country": "CH",
  "artist": "Lys Assia",
  "song": "Refrain",
  "year": "1956",
  "place": "1",
  "spotify": "0OtKMBmhEuQ4hGPbMmtErz"
};